/* eslint-disable no-return-await, no-template-curly-in-string */
import { fetchJson, fetchJsonWithRetries } from 'surface/api_fetch'
import { HTTPMethod } from '@padlet/fetch'
import template from 'lodash.template'
class FetchableObject {
  static get url () {
    return ''
  }

  static get fetchUrl () {
    return ''
  }

  static buildUrl (url, options) {
    return template(url)({ ...options, interpolate: /\${([\s\S]+?)}/g })
  }

  static async readAll (options, fetchOptions = {}) {
    return await fetchJson(this.buildUrl(this.fetchUrl, options), {
      method: HTTPMethod.get,
      ...fetchOptions,
    })
  }

  static async read (obj, fetchOptions = {}) {
    return await fetchJson(`${this.url}/${obj.id}`, {
      method: HTTPMethod.get,
      ...fetchOptions,
    })
  }

  static async update (obj, fetchOptions = {}) {
    return await fetchJson(`${this.url}/${obj.id}`, {
      method: HTTPMethod.put,
      body: JSON.stringify(obj),
      ...fetchOptions,
    })
  }

  static async create (obj, fetchOptions = {}) {
    return await fetchJson(`${this.url}`, {
      method: HTTPMethod.post,
      body: JSON.stringify(obj),
      ...fetchOptions,
    })
  }

  static async delete (obj, fetchOptions = {}) {
    return await fetchJson(`${this.url}/${obj.id}`, {
      method: HTTPMethod.delete,
      ...fetchOptions,
    })
  }
}

class Reaction extends FetchableObject {
  static get url () {
    return '/reactions'
  }

  static get fetchUrl () {
    return '/reactions?wall_id=${ wall.id }'
  }
}

class PostConnection extends FetchableObject {
  static get url () {
    return '/api/wish_connections'
  }

  static get fetchUrl () {
    return '/api/wish_connections?wall_id=${ wall.id }'
  }
}

class Comment extends FetchableObject {
  static get url () {
    return '/comments'
  }

  static get fetchUrl () {
    return '/comments?wall_id=${ wall.id }'
  }
}

class WallSection extends FetchableObject {
  static get url () {
    return '/wall_sections'
  }

  static get fetchUrl () {
    return '/wall_sections?wall_id=${ wall.id }'
  }
}

class Wall extends FetchableObject {
  static get url () {
    return '/walls'
  }

  private static get convertLayoutUrl (): string {
    return '/walls/${ id }/layout'
  }

  public static async convertLayout ({ id, newLayout }, fetchOptions = {}): Promise<any> {
    return await fetchJson(this.buildUrl(this.convertLayoutUrl, { id }), {
      method: HTTPMethod.put,
      body: JSON.stringify({ type: newLayout }),
      ...fetchOptions,
    })
  }
}

class Wish extends FetchableObject {
  static get url () {
    return '/wishes'
  }

  static get fetchUrl () {
    return '/wishes?wall_id=${ wall.id }'
  }

  static get transferUrl () {
    return '/wishes/${ wish_id }/transfer'
  }

  static get copyUrl () {
    return '/wishes/${ wish_id }/copy'
  }

  static get approveUrl () {
    return '/wishes/${ wish_id }/approve'
  }

  static async transfer ({
    wishId, wallId, wallSectionId, wallTitle, wallDescription,
  }, fetchOptions = {}) {
    return await fetchJson(this.buildUrl(this.transferUrl, { wish_id: wishId }), {
      method: HTTPMethod.put,
      body: JSON.stringify({
        wall_id: wallId,
        wall_section_id: wallSectionId,
        wall_title: wallTitle,
        wall_description: wallDescription,
      }),
      ...fetchOptions,
    })
  }

  static async copy ({
    wishId, wallId, wallSectionId, wallTitle, wallDescription, postPosition,
  }, fetchOptions = {}) {
    return await fetchJson(this.buildUrl(this.copyUrl, { wish_id: wishId }), {
      method: HTTPMethod.post,
      body: JSON.stringify({
        wall_id: wallId,
        wall_section_id: wallSectionId,
        wall_title: wallTitle,
        wall_description: wallDescription,
        ...postPosition,
      }),
      ...fetchOptions,
    })
  }

  static async approve ({ wishId }, fetchOptions = {}) {
    return await fetchJson(this.buildUrl(this.approveUrl, { wish_id: wishId }), {
      method: HTTPMethod.put,
      body: JSON.stringify({
      }),
      ...fetchOptions,
    })
  }

  static async update (obj, fetchOptions = {}) {
    return await fetchJsonWithRetries(`${this.url}/${obj.id}`, {
      method: HTTPMethod.put,
      body: JSON.stringify(obj),
      ...fetchOptions,
    })
  }
}

export default {
  Reaction: Reaction,
  PostConnection: PostConnection,
  Comment: Comment,
  WallSection: WallSection,
  Wall: Wall,
  Wish: Wish,
}
